export default __webpack_public_path__ + "static/media/1.2fa5e7f6.jpeg";